import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const store = new Vuex.Store({
    state:{
        userInfo:'',
        gameData:'',
    },
    mutations:{
        setUserInfo(state,value){
            state.userInfo = value;
        },
        setGameData(state,value){
            state.gameData = value;
        }
    },
    getters:{
        userInfo:state => state.userInfo,
        gameData:state => state.gameData,
     }
});

export default store


// WEBPACK FOOTER //
// ./src/store/index.js